import React, { Component, createRef } from 'react';
import { Container } from 'react-bootstrap';
import './_parentEnquiry.scss';

// ── Rich Static Student Database ───────────────────────────────────────────────
const STUDENT_DB = {
  '9876543210': {
    parent:  { name: 'Rajesh Kumar',   relation: 'Father', mobile: '9876543210' },
    student: {
      name: 'Arjun Kumar',
      admissionNo: 'ADM-2024-0187',
      class: '10', section: 'A', rollNo: 15,
      gender: 'Male', dob: '12 Mar 2009', bloodGroup: 'O+',
      institution: 'Rizee College', branch: 'Main Campus',
      attendance: {
        overall: 87, thisMonth: 92,
        totalWorkingDays: 120, daysPresent: 104,
        bySubject: [
          { subject: 'Physics',     present: 38, total: 44, percent: 86 },
          { subject: 'Chemistry',   present: 40, total: 44, percent: 91 },
          { subject: 'Mathematics', present: 42, total: 44, percent: 95 },
          { subject: 'English',     present: 43, total: 44, percent: 98 },
          { subject: 'Biology',     present: 36, total: 44, percent: 82 },
        ],
      },
      exams: [
        {
          name: 'Unit Test 2', date: 'May 8, 2026',
          totalStudents: 42, percentage: 87.2, rank: 4,
          marks: [
            { subject: 'Physics',     obtained: 42, max: 50 },
            { subject: 'Chemistry',   obtained: 45, max: 50 },
            { subject: 'Mathematics', obtained: 48, max: 50 },
            { subject: 'English',     obtained: 44, max: 50 },
            { subject: 'Biology',     obtained: 39, max: 50 },
          ],
        },
        {
          name: 'Mid Term Exam', date: 'Mar 20, 2026',
          totalStudents: 42, percentage: 82.0, rank: 7,
          marks: [
            { subject: 'Physics',     obtained: 78,  max: 100 },
            { subject: 'Chemistry',   obtained: 85,  max: 100 },
            { subject: 'Mathematics', obtained: 91,  max: 100 },
            { subject: 'English',     obtained: 82,  max: 100 },
            { subject: 'Biology',     obtained: 74,  max: 100 },
          ],
        },
      ],
      fees: {
        totalAnnual: 85000, paid: 60000, pending: 25000,
        nextDueDate: 'June 5, 2026', nextDueAmount: 25000,
        history: [
          { date: 'Apr 1, 2026',  desc: 'Q4 Tuition Fee', amount: 20000, paid: true },
          { date: 'Jan 5, 2026',  desc: 'Q3 Tuition Fee', amount: 20000, paid: true },
          { date: 'Oct 3, 2025',  desc: 'Q2 Tuition Fee', amount: 20000, paid: true },
        ],
      },
      classTeacher: { name: 'Mrs. Lakshmi Devi', subject: 'Mathematics', contact: '9876500111' },
      subjects: [
        { name: 'Physics',     teacher: 'Mr. Ravi Shankar'   },
        { name: 'Chemistry',   teacher: 'Mrs. Anita Reddy'   },
        { name: 'Mathematics', teacher: 'Mrs. Lakshmi Devi'  },
        { name: 'English',     teacher: 'Mr. John Abraham'   },
        { name: 'Biology',     teacher: 'Mrs. Fatima Begum'  },
      ],
      timetable: {
        Monday:    ['Physics',   'Chemistry', 'Maths',   'English',   'Biology',   'Maths'     ],
        Tuesday:   ['English',   'Physics',   'Biology', 'Chemistry', 'Maths',     'Physics'   ],
        Wednesday: ['Maths',     'Biology',   'English', 'Physics',   'Chemistry', 'English'   ],
        Thursday:  ['Chemistry', 'Maths',     'Physics', 'Biology',   'English',   'Chemistry' ],
        Friday:    ['Biology',   'English',   'Chemistry','Maths',    'Physics',   'Biology'   ],
        Saturday:  ['Maths',     'Physics',   'Chemistry','English',  '—',         '—'         ],
      },
      timings: ['8:00–8:45','8:45–9:30','9:30–10:15','10:30–11:15','11:15–12:00','12:00–12:45'],
      upcomingEvents: [
        { date: 'May 25, 2026', title: 'Parent-Teacher Meeting', detail: '10 AM – 1 PM, Main Hall' },
        { date: 'Jun 5, 2026',  title: 'Fee Due Date',           detail: '₹25,000 pending' },
        { date: 'Jun 8–12',     title: 'Board Practicals',       detail: 'Physics & Chemistry practicals' },
        { date: 'Jun 20, 2026', title: 'Pre-Board Exams',        detail: 'Pre-board exams begin for Class 10' },
      ],
      remarks: [
        { date: 'May 10, 2026', by: 'Mrs. Lakshmi Devi', text: 'Excellent — secured 2nd place in Mathematics Olympiad.' },
        { date: 'Apr 5, 2026',  by: 'Mr. Ravi Shankar',  text: 'Needs to improve attention in Physics practical sessions.' },
      ],
    },
  },

  '8765432109': {
    parent:  { name: 'Priya Sharma', relation: 'Mother', mobile: '8765432109' },
    student: {
      name: 'Ananya Sharma',
      admissionNo: 'ADM-2023-0094',
      class: '8', section: 'B', rollNo: 7,
      gender: 'Female', dob: '22 Sep 2011', bloodGroup: 'A+',
      institution: 'Rizee School', branch: 'Koramangala Branch',
      attendance: {
        overall: 91, thisMonth: 95,
        totalWorkingDays: 120, daysPresent: 109,
        bySubject: [
          { subject: 'Science',   present: 42, total: 44, percent: 95 },
          { subject: 'Maths',     present: 43, total: 44, percent: 98 },
          { subject: 'English',   present: 44, total: 44, percent: 100 },
          { subject: 'Social',    present: 40, total: 44, percent: 91 },
          { subject: 'Hindi',     present: 38, total: 44, percent: 86 },
        ],
      },
      exams: [
        {
          name: 'Unit Test 2', date: 'May 10, 2026',
          totalStudents: 38, percentage: 91.6, rank: 2,
          marks: [
            { subject: 'Science', obtained: 47, max: 50 },
            { subject: 'Maths',   obtained: 49, max: 50 },
            { subject: 'English', obtained: 46, max: 50 },
            { subject: 'Social',  obtained: 44, max: 50 },
            { subject: 'Hindi',   obtained: 42, max: 50 },
          ],
        },
        {
          name: 'Mid Term Exam', date: 'Mar 22, 2026',
          totalStudents: 38, percentage: 88.4, rank: 3,
          marks: [
            { subject: 'Science', obtained: 90,  max: 100 },
            { subject: 'Maths',   obtained: 94,  max: 100 },
            { subject: 'English', obtained: 88,  max: 100 },
            { subject: 'Social',  obtained: 85,  max: 100 },
            { subject: 'Hindi',   obtained: 87,  max: 100 },
          ],
        },
      ],
      fees: {
        totalAnnual: 62000, paid: 62000, pending: 0,
        nextDueDate: 'Jul 1, 2026 (Next Year)', nextDueAmount: 65000,
        history: [
          { date: 'Apr 2, 2026',  desc: 'Q4 Tuition Fee', amount: 15000, paid: true },
          { date: 'Jan 6, 2026',  desc: 'Q3 Tuition Fee', amount: 15000, paid: true },
          { date: 'Oct 5, 2025',  desc: 'Q2 Tuition Fee', amount: 17000, paid: true },
          { date: 'Jun 12, 2025', desc: 'Q1 Tuition + Admission', amount: 15000, paid: true },
        ],
      },
      classTeacher: { name: 'Mr. Suresh Babu', subject: 'English', contact: '9988776655' },
      subjects: [
        { name: 'Science', teacher: 'Mrs. Kavitha Nair'  },
        { name: 'Maths',   teacher: 'Mr. Prasad Rao'     },
        { name: 'English', teacher: 'Mr. Suresh Babu'    },
        { name: 'Social',  teacher: 'Mrs. Usha Rani'     },
        { name: 'Hindi',   teacher: 'Mrs. Rekha Mishra'  },
      ],
      timetable: {
        Monday:    ['Maths',   'Science', 'English', 'Social',  'Hindi',   'Maths'   ],
        Tuesday:   ['English', 'Maths',   'Social',  'Science', 'Maths',   'Hindi'   ],
        Wednesday: ['Science', 'English', 'Hindi',   'Maths',   'Social',  'Science' ],
        Thursday:  ['Social',  'Hindi',   'Maths',   'English', 'Science', 'English' ],
        Friday:    ['Hindi',   'Social',  'Science', 'Hindi',   'Maths',   'Social'  ],
        Saturday:  ['Maths',   'English', 'Science', 'Maths',   '—',       '—'       ],
      },
      timings: ['8:00–8:45','8:45–9:30','9:30–10:15','10:30–11:15','11:15–12:00','12:00–12:45'],
      upcomingEvents: [
        { date: 'May 28, 2026', title: 'Science Exhibition',  detail: 'Ananya is presenting a project' },
        { date: 'Jun 3, 2026',  title: 'Annual Sports Day',   detail: '9 AM at School Grounds' },
        { date: 'Jun 20, 2026', title: 'Term-End Exams',      detail: 'Final exams for Term II' },
        { date: 'Jul 1, 2026',  title: 'New Academic Year Fee Due', detail: '₹65,000 for next year' },
      ],
      remarks: [
        { date: 'May 12, 2026', by: 'Mr. Suresh Babu', text: 'Outstanding reading and comprehension skills. Represents the class in essay competitions.' },
        { date: 'Mar 30, 2026', by: 'Mrs. Kavitha Nair', text: 'Very curious and participative in Science labs. Excellent work this term.' },
      ],
    },
  },

  '7654321098': {
    parent:  { name: 'Mohammed Rizwan', relation: 'Father', mobile: '7654321098' },
    student: {
      name: 'Zaid Rizwan',
      admissionNo: 'ADM-2022-0321',
      class: '12', section: 'C', rollNo: 22,
      gender: 'Male', dob: '04 Jul 2007', bloodGroup: 'B+',
      institution: 'Rizee College', branch: 'Main Campus',
      attendance: {
        overall: 79, thisMonth: 83,
        totalWorkingDays: 120, daysPresent: 95,
        bySubject: [
          { subject: 'Physics',     present: 35, total: 44, percent: 80 },
          { subject: 'Chemistry',   present: 34, total: 44, percent: 77 },
          { subject: 'Mathematics', present: 37, total: 44, percent: 84 },
          { subject: 'English',     present: 38, total: 44, percent: 86 },
          { subject: 'Biology',     present: 33, total: 44, percent: 75 },
        ],
      },
      exams: [
        {
          name: 'Unit Test 2', date: 'May 12, 2026',
          totalStudents: 44, percentage: 84.0, rank: 8,
          marks: [
            { subject: 'Physics',     obtained: 41, max: 50 },
            { subject: 'Chemistry',   obtained: 43, max: 50 },
            { subject: 'Mathematics', obtained: 44, max: 50 },
            { subject: 'English',     obtained: 40, max: 50 },
            { subject: 'Biology',     obtained: 42, max: 50 },
          ],
        },
        {
          name: 'Class 11 Final', date: 'Apr 5, 2026',
          totalStudents: 44, percentage: 91.2, rank: 3,
          marks: [
            { subject: 'Physics',     obtained: 88, max: 100 },
            { subject: 'Chemistry',   obtained: 92, max: 100 },
            { subject: 'Mathematics', obtained: 95, max: 100 },
            { subject: 'English',     obtained: 89, max: 100 },
            { subject: 'Biology',     obtained: 92, max: 100 },
          ],
        },
      ],
      fees: {
        totalAnnual: 92000, paid: 69000, pending: 23000,
        nextDueDate: 'June 10, 2026', nextDueAmount: 23000,
        history: [
          { date: 'Mar 15, 2026', desc: 'Q3 + Lab Fee', amount: 23000, paid: true },
          { date: 'Dec 3, 2025',  desc: 'Q2 Tuition Fee', amount: 23000, paid: true },
          { date: 'Sep 1, 2025',  desc: 'Q1 Tuition Fee', amount: 23000, paid: true },
        ],
      },
      classTeacher: { name: 'Dr. Arvind Sharma', subject: 'Physics', contact: '9001122334' },
      subjects: [
        { name: 'Physics',     teacher: 'Dr. Arvind Sharma'   },
        { name: 'Chemistry',   teacher: 'Mrs. Sunitha Rao'    },
        { name: 'Mathematics', teacher: 'Mr. Kiran Bhaskar'   },
        { name: 'English',     teacher: 'Mrs. Deepa Nair'     },
        { name: 'Biology',     teacher: 'Mr. Imran Khan'      },
      ],
      timetable: {
        Monday:    ['Physics',   'Chemistry', 'Maths',    'English', 'Biology',   'Physics'   ],
        Tuesday:   ['Chemistry', 'Maths',     'Physics',  'Biology', 'English',   'Chemistry' ],
        Wednesday: ['Maths',     'Physics',   'Biology',  'Maths',   'Chemistry', 'English'   ],
        Thursday:  ['Biology',   'English',   'Chemistry','Physics', 'Maths',     'Biology'   ],
        Friday:    ['English',   'Biology',   'Maths',    'Chemistry','Physics',  'Maths'     ],
        Saturday:  ['Physics',   'Chemistry', 'Maths',    'English', '—',         '—'         ],
      },
      timings: ['8:00–8:45','8:45–9:30','9:30–10:15','10:30–11:15','11:15–12:00','12:00–12:45'],
      upcomingEvents: [
        { date: 'Jun 6–10, 2026', title: 'Board Practicals',  detail: 'All science subjects — bring journal' },
        { date: 'Jun 10, 2026',   title: 'Fee Due',           detail: '₹23,000 remaining balance' },
        { date: 'Jun 22, 2026',   title: 'Pre-Board Exams',   detail: 'Covers full Class 12 syllabus' },
        { date: 'Jul 15, 2026',   title: 'Board Exams Begin', detail: 'CBSE/State Board Class 12' },
      ],
      remarks: [
        { date: 'May 5, 2026',  by: 'Dr. Arvind Sharma', text: 'Excellent conceptual understanding in Physics. One of the top performers in the batch.' },
        { date: 'Apr 20, 2026', by: 'Mrs. Sunitha Rao',  text: 'Attendance is slightly low in Chemistry. Please ensure regular attendance before board exams.' },
      ],
    },
  },
};

// ── AI Response Engine ─────────────────────────────────────────────────────────
function now() {
  return new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
}

function pct(val) {
  if (val >= 90) return 'peq-tbl-good';
  if (val >= 75) return 'peq-tbl-neutral';
  return 'peq-tbl-warn';
}

function hasKw(q, words) {
  return words.some((w) => q.includes(w));
}

function buildResponse(q, s, parent) {
  const lq = q.toLowerCase();

  // ── Attendance ──
  if (hasKw(lq, ['attend','present','absent','bunk','missed','days present','how many days'])) {
    const a = s.attendance;

    // Subject-specific
    const subMatch = a.bySubject.find((sub) => lq.includes(sub.subject.toLowerCase()));
    if (subMatch) {
      const status = subMatch.percent >= 75 ? '✅ Good' : '⚠️ Below 75% — at risk';
      return {
        text: `${s.name}'s **${subMatch.subject}** attendance is **${subMatch.percent}%** (${subMatch.present} out of ${subMatch.total} classes attended). Status: ${status}.`,
        table: null,
        suggestions: ['Show all subject attendance', 'What is overall attendance?', 'Which subject needs improvement?'],
      };
    }

    // All subjects
    if (hasKw(lq, ['subject','each','all subject','subjectwise'])) {
      return {
        text: `Here is **${s.name}'s subject-wise attendance:**`,
        table: {
          headers: ['Subject', 'Present', 'Total Classes', 'Attendance %'],
          rows: a.bySubject.map((sub) => [
            sub.subject, sub.present, sub.total, { value: `${sub.percent}%`, cls: pct(sub.percent) },
          ]),
        },
        suggestions: ['Which subject is lowest?', 'Show overall attendance', 'Show exam marks'],
      };
    }

    // Overall
    const status = a.overall >= 75
      ? `✅ Good standing (above 75% minimum)`
      : `⚠️ Below 75% — student may be detained`;
    return {
      text: `**${s.name}'s Attendance Summary**\n\n• Overall: **${a.overall}%** (${a.daysPresent}/${a.totalWorkingDays} days)\n• This Month: **${a.thisMonth}%**\n• Status: ${status}`,
      table: null,
      suggestions: ['Show subject-wise attendance', 'Which subject has lowest attendance?', 'Show upcoming events'],
    };
  }

  // ── Lowest attendance subject ──
  if (hasKw(lq, ['lowest','weakest','poor attendance','least attendance','which subject'])) {
    const sorted = [...s.attendance.bySubject].sort((a, b) => a.percent - b.percent);
    const low = sorted[0];
    return {
      text: `The subject with **lowest attendance** is **${low.subject}** at **${low.percent}%** (${low.present}/${low.total} classes). ${low.percent < 75 ? '⚠️ This is below the required 75% — immediate attention needed.' : ''}`,
      table: {
        headers: ['Subject', 'Attendance %'],
        rows: sorted.map((s2) => [s2.subject, { value: `${s2.percent}%`, cls: pct(s2.percent) }]),
      },
      suggestions: ['Show all attendance', 'Show marks', 'Show timetable'],
    };
  }

  // ── Marks / Exams ──
  if (hasKw(lq, ['mark','score','result','exam','test','grade','percentage','obtained','rank','performance'])) {
    const latest = s.exams[0];
    const prev   = s.exams[1];

    // Comparison / trend
    if (prev && hasKw(lq, ['improv','trend','compar','progress','previous','last exam','both'])) {
      const up = latest.percentage > prev.percentage;
      const diff = Math.abs(latest.percentage - prev.percentage).toFixed(1);
      return {
        text: `**Performance Trend for ${s.name}:**\n\n${prev.name}: **${prev.percentage}%** (Rank ${prev.rank}) → ${latest.name}: **${latest.percentage}%** (Rank ${latest.rank})\n\n${up ? `📈 Improved by **${diff}%** — great progress!` : `📉 Declined by **${diff}%** — needs attention.`}`,
        table: {
          headers: ['Subject', prev.name, latest.name, 'Change'],
          rows: latest.marks.map((m, i) => {
            const p = prev.marks[i];
            const prevPct = Math.round((p.obtained / p.max) * 100);
            const latPct  = Math.round((m.obtained / m.max) * 100);
            const diff2   = latPct - prevPct;
            return [m.subject, `${p.obtained}/${p.max}`, `${m.obtained}/${m.max}`, {
              value: diff2 > 0 ? `+${diff2}%` : `${diff2}%`,
              cls: diff2 > 0 ? 'peq-tbl-good' : diff2 < 0 ? 'peq-tbl-warn' : 'peq-tbl-neutral',
            }];
          }),
        },
        suggestions: ['Show latest exam marks in detail', 'Show attendance', 'Show upcoming exams'],
      };
    }

    // Default: latest exam
    const totalObtained = latest.marks.reduce((s2, m) => s2 + m.obtained, 0);
    const totalMax      = latest.marks.reduce((s2, m) => s2 + m.max, 0);
    return {
      text: `**${latest.name}** (${latest.date})\n\n${s.name} scored **${totalObtained}/${totalMax} — ${latest.percentage}%**\nClass Rank: **${latest.rank}** out of ${latest.totalStudents} students`,
      table: {
        headers: ['Subject', 'Marks', 'Out of', '%'],
        rows: latest.marks.map((m) => {
          const p2 = Math.round((m.obtained / m.max) * 100);
          return [m.subject, m.obtained, m.max, { value: `${p2}%`, cls: pct(p2) }];
        }),
      },
      suggestions: ['Show performance trend vs previous exam', 'Show attendance', 'Show fee status'],
    };
  }

  // ── Fee ──
  if (hasKw(lq, ['fee','payment','paid','pending','due','amount','money','balance','challan'])) {
    const f = s.fees;
    const allPaid = f.pending === 0;
    return {
      text: `**Fee Status for ${s.name}:**\n\n• Annual Fee: ₹${f.totalAnnual.toLocaleString()}\n• Paid: ₹${f.paid.toLocaleString()} ✅\n• Pending: ${allPaid ? '₹0 — Fully Paid ✅' : `**₹${f.pending.toLocaleString()} ⚠️**`}\n• Next Due: **${f.nextDueDate}**${!allPaid ? ` — ₹${f.nextDueAmount.toLocaleString()}` : ''}`,
      table: {
        headers: ['Date', 'Description', 'Amount', 'Status'],
        rows: f.history.map((h) => [h.date, h.desc, `₹${h.amount.toLocaleString()}`, { value: h.paid ? '✅ Paid' : '⏳ Pending', cls: h.paid ? 'peq-tbl-good' : 'peq-tbl-warn' }]),
      },
      suggestions: ['When is the next due date?', 'Show upcoming events', 'Show exam marks'],
    };
  }

  // ── Teacher / Staff ──
  if (hasKw(lq, ['teacher','staff','faculty','contact','tutor','class teacher','who teach','hod'])) {
    const ct = s.classTeacher;
    return {
      text: `**Class Teacher:** ${ct.name} (${ct.subject}) — 📞 ${ct.contact}\n\nSubject teachers for ${s.name}:`,
      table: {
        headers: ['Subject', 'Teacher Name'],
        rows: s.subjects.map((sub) => [sub.name, sub.teacher]),
      },
      suggestions: ['Show timetable', 'When is PTM?', 'Show attendance'],
    };
  }

  // ── Timetable ──
  if (hasKw(lq, ['timetable','schedule','period','timing','class time','today','what class','which period'])) {
    const days = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const matchedDay = days.find((d) => lq.includes(d.toLowerCase()));
    const todayName  = new Date().toLocaleString('en-US', { weekday: 'long' });
    const targetDay  = matchedDay || (days.includes(todayName) ? todayName : 'Monday');
    const periods    = s.timetable[targetDay] || [];
    return {
      text: `**${targetDay}'s class schedule for ${s.name}:**`,
      table: {
        headers: ['Period', 'Timing', 'Subject'],
        rows: periods.map((sub, i) => [`Period ${i + 1}`, s.timings[i], sub === '—' ? { value: '—', cls: 'peq-tbl-neutral' } : sub]),
      },
      suggestions: ['Show teacher contacts', 'Show attendance', 'Show upcoming events'],
    };
  }

  // ── Events / Calendar ──
  if (hasKw(lq, ['event','holiday','upcoming','calendar','ptm','parent meet','exam date','schedule'])) {
    return {
      text: `**Upcoming events for ${s.name}:**`,
      table: {
        headers: ['Date', 'Event', 'Details'],
        rows: s.upcomingEvents.map((e) => [e.date, e.title, e.detail]),
      },
      suggestions: ['When is PTM?', 'Show fee due date', 'Show timetable'],
    };
  }

  // ── Remarks / Behavior ──
  if (hasKw(lq, ['remark','comment','behav','conduct','feedback','teacher said','note'])) {
    return {
      text: `**Teacher remarks about ${s.name}:**`,
      list: s.remarks.map((r) => `[${r.date}] **${r.by}:** "${r.text}"`),
      table: null,
      suggestions: ['Show attendance', 'Show marks', 'Show upcoming events'],
    };
  }

  // ── Overall summary ──
  if (hasKw(lq, ['summary','overview','how is','overall','report','tell me about','about my child','about him','about her'])) {
    const ex = s.exams[0];
    const attStatus = s.attendance.overall >= 75 ? '✅ Good' : '⚠️ Needs improvement';
    const feeStatus = s.fees.pending === 0 ? '✅ Fully paid' : `⚠️ ₹${s.fees.pending.toLocaleString()} pending`;
    return {
      text: `**Overview for ${s.name} (Class ${s.class}-${s.section})**\n\n📊 Attendance: **${s.attendance.overall}%** — ${attStatus}\n📝 Latest Exam: **${ex.name} — ${ex.percentage}%** (Rank ${ex.rank}/${ex.totalStudents})\n💳 Fee: ${feeStatus}\n🏫 Institution: ${s.institution}, ${s.branch}`,
      table: null,
      suggestions: ['Show detailed attendance', 'Show exam marks', 'Show fee details', 'Show upcoming events'],
    };
  }

  // ── Greeting ──
  if (hasKw(lq, ['hi','hello','hey','good morning','good afternoon','namaste','hii'])) {
    return {
      text: `Hello **${parent.name}**! 👋\n\nI'm your AI assistant for **${s.name}'s** school updates. You can ask me about:\n\n• 📊 Attendance (overall & subject-wise)\n• 📝 Exam marks & performance trends\n• 💳 Fee status & payment history\n• 📅 Timetable & class schedule\n• 👩‍🏫 Teachers & contact details\n• 📌 Upcoming events & exam dates\n• 💬 Teacher remarks & feedback`,
      table: null,
      suggestions: ['What is attendance?', 'Show latest marks', 'Show fee status', 'Upcoming events'],
    };
  }

  // ── Fallback ──
  return {
    text: `I can help you get information about **${s.name}**. Try asking about:\n\n• 📊 **Attendance** — "What is the attendance?"\n• 📝 **Marks** — "Show latest exam results"\n• 💳 **Fees** — "Is fee paid?"\n• 📅 **Timetable** — "What is today's schedule?"\n• 👩‍🏫 **Teachers** — "Who is the class teacher?"\n• 📌 **Events** — "Any upcoming exams?"`,
    table: null,
    suggestions: ['What is the attendance?', 'Show latest exam marks', 'Is fee pending?', 'Show timetable'],
  };
}

// ── Helpers ────────────────────────────────────────────────────────────────────
function initials(name) {
  return name.split(' ').slice(0, 2).map((w) => w[0]).join('').toUpperCase();
}

function renderBoldText(text) {
  const parts = text.split(/\*\*(.*?)\*\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part
  );
}

const WELCOME_SUGGESTIONS = [
  { icon: 'fal fa-calendar-check', label: 'Attendance' },
  { icon: 'fal fa-file-alt',       label: 'Exam Marks' },
  { icon: 'fal fa-credit-card',    label: 'Fee Status' },
  { icon: 'fal fa-clock',          label: 'Timetable' },
  { icon: 'fal fa-chalkboard-teacher', label: 'Teachers' },
  { icon: 'fal fa-calendar-alt',   label: 'Events' },
];

const DEMO_NUMBERS = [
  { num: '9876543210', name: 'Rajesh Kumar (Father)' },
  { num: '8765432109', name: 'Priya Sharma (Mother)' },
  { num: '7654321098', name: 'Mohammed Rizwan (Father)' },
];

// ── Component ──────────────────────────────────────────────────────────────────
class ParentEnquirySection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: '',
      loading: false,
      record: null,
      notFound: false,
      messages: [],
      inputText: '',
      aiTyping: false,
      toast: null,
    };
    this.messagesEndRef = createRef();
    this.inputRef       = createRef();
    this.toastTimer     = null;
  }

  componentWillUnmount() {
    if (this.toastTimer) clearTimeout(this.toastTimer);
  }

  scrollToBottom() {
    setTimeout(() => {
      if (this.messagesEndRef.current) {
        this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 80);
  }

  // ── Search ──────────────────────────────────────────────────────────────────
  handleSearch = () => {
    const { mobile } = this.state;
    const num = mobile.trim().replace(/\D/g, '');
    if (!/^\d{10}$/.test(num)) {
      this.showToast('Please enter a valid 10-digit mobile number.');
      return;
    }
    this.setState({ loading: true, notFound: false, record: null, messages: [] });
    setTimeout(() => {
      const record = STUDENT_DB[num] || null;
      if (!record) {
        this.setState({ loading: false, notFound: true });
        return;
      }
      const { parent, student } = record;
      const greeting = buildResponse('hello', student, parent);
      this.setState({
        loading: false,
        record,
        notFound: false,
        messages: [
          {
            id: Date.now(),
            role: 'ai',
            ...greeting,
            time: now(),
          },
        ],
      });
      this.scrollToBottom();
    }, 900);
  };

  handleReset = () => {
    this.setState({ mobile: '', record: null, notFound: false, messages: [], inputText: '' });
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') this.handleSearch();
  };

  tryDemo = (num) => {
    this.setState({ mobile: num }, this.handleSearch);
  };

  // ── Chat ────────────────────────────────────────────────────────────────────
  handleSend = () => {
    const { inputText, record, messages } = this.state;
    const text = inputText.trim();
    if (!text || !record) return;

    const userMsg = { id: Date.now(), role: 'user', text, time: now() };
    this.setState({ messages: [...messages, userMsg], inputText: '', aiTyping: true }, () => {
      this.scrollToBottom();
    });

    setTimeout(() => {
      const response = buildResponse(text, record.student, record.parent);
      const aiMsg = { id: Date.now() + 1, role: 'ai', ...response, time: now() };
      this.setState((prev) => ({
        messages: [...prev.messages, aiMsg],
        aiTyping: false,
      }), () => {
        this.scrollToBottom();
        if (this.inputRef.current) this.inputRef.current.focus();
      });
    }, 1100 + Math.random() * 600);
  };

  handleInputKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      this.handleSend();
    }
  };

  handleSuggestion = (suggestion) => {
    this.setState({ inputText: suggestion }, () => {
      this.handleSend();
    });
  };

  handleTopicChip = (label) => {
    const questions = {
      'Attendance':  'What is the attendance?',
      'Exam Marks':  'Show latest exam marks',
      'Fee Status':  'What is the fee status?',
      'Timetable':   'Show today\'s timetable',
      'Teachers':    'Who are the subject teachers?',
      'Events':      'What are the upcoming events?',
    };
    const q = questions[label] || label;
    this.setState({ inputText: q }, this.handleSend);
  };

  showToast(msg) {
    if (this.toastTimer) clearTimeout(this.toastTimer);
    this.setState({ toast: msg });
    this.toastTimer = setTimeout(() => this.setState({ toast: null }), 3000);
  }

  // ── Render Helpers ──────────────────────────────────────────────────────────
  renderTable(table) {
    if (!table) return null;
    return (
      <table className="peq-ai-table">
        <thead>
          <tr>{table.headers.map((h, i) => <th key={i}>{h}</th>)}</tr>
        </thead>
        <tbody>
          {table.rows.map((row, ri) => (
            <tr key={ri}>
              {row.map((cell, ci) => {
                const isObj = cell && typeof cell === 'object' && cell.value !== undefined;
                return (
                  <td key={ci} className={isObj ? cell.cls : ''}>
                    {isObj ? cell.value : cell}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  renderAIMessage(msg) {
    return (
      <div key={msg.id} className="peq-msg peq-msg-ai">
        <div className="peq-msg-avatar"><i className="fal fa-robot" /></div>
        <div className="peq-msg-bubble">
          <p className="peq-msg-label">AI Assistant</p>
          <p className="peq-msg-text">{renderBoldText(msg.text)}</p>
          {msg.table && this.renderTable(msg.table)}
          {msg.list && (
            <ul className="peq-ai-list">
              {msg.list.map((item, i) => (
                <li key={i}><i className="fal fa-chevron-right" /><span>{renderBoldText(item)}</span></li>
              ))}
            </ul>
          )}
          <p className="peq-msg-time">{msg.time}</p>
        </div>
      </div>
    );
  }

  renderUserMessage(msg) {
    const { record } = this.state;
    const name = record ? record.parent.name : 'You';
    return (
      <div key={msg.id} className="peq-msg peq-msg-user">
        <div className="peq-msg-avatar">{initials(name)}</div>
        <div className="peq-msg-bubble">
          <p className="peq-msg-text">{msg.text}</p>
          <p className="peq-msg-time light">{msg.time}</p>
        </div>
      </div>
    );
  }

  renderTypingIndicator() {
    return (
      <div className="peq-msg peq-msg-ai">
        <div className="peq-msg-avatar"><i className="fal fa-robot" /></div>
        <div className="peq-msg-bubble peq-typing-bubble">
          <span /><span /><span />
        </div>
      </div>
    );
  }

  render() {
    const { mobile, loading, record, notFound, messages, inputText, aiTyping, toast } = this.state;
    const lastAIMsg  = [...messages].reverse().find((m) => m.role === 'ai');
    const suggestions = lastAIMsg ? lastAIMsg.suggestions : [];

    return (
      <div className="peq-page">
        {/* Hero */}
        <div className="peq-hero">
          <div className="peq-hero-badge"><i className="fal fa-robot" />AI Assistant</div>
          <h1>Parent AI Assistant</h1>
          <p>Ask any question about your child's academics, attendance, fees & more.</p>
        </div>

        <Container fluid style={{ maxWidth: 860, padding: '0 16px 40px' }}>
          {/* Search */}
          <div className="peq-search-card">
            <span className="peq-search-label">
              <i className="fal fa-mobile-alt" style={{ marginRight: 6, color: '#1d9c6e' }} />
              Enter Parent Mobile Number
            </span>
            <div className="peq-search-row">
              <div className="peq-input-wrap">
                <i className="fal fa-phone peq-input-icon" />
                <input
                  type="tel"
                  maxLength={10}
                  placeholder="e.g. 9876543210"
                  value={mobile}
                  onChange={(e) => this.setState({ mobile: e.target.value.replace(/\D/g, '') })}
                  onKeyDown={this.handleKeyDown}
                  disabled={!!record}
                />
              </div>
              {record ? (
                <button className="peq-search-btn" onClick={this.handleReset} style={{ background: '#ef4444' }}>
                  <i className="fal fa-times" />New Search
                </button>
              ) : (
                <button className="peq-search-btn" onClick={this.handleSearch} disabled={loading}>
                  {loading
                    ? <><span style={{ width: 13, height: 13, border: '2px solid rgba(255,255,255,0.35)', borderTopColor: '#fff', borderRadius: '50%', display: 'inline-block', animation: 'peq-spin 0.7s linear infinite' }} />Searching…</>
                    : <><i className="fal fa-search" />Search</>}
                </button>
              )}
            </div>
            {!record && (
              <p className="peq-search-hint">
                <i className="fal fa-info-circle" />
                Enter the mobile number registered at the time of student admission.
              </p>
            )}
          </div>

          <div style={{ marginTop: 20 }}>
            {/* Loading */}
            {loading && (
              <div className="peq-loading">
                <div className="peq-spinner" />
                <p>Fetching student records…</p>
              </div>
            )}

            {/* Not found */}
            {!loading && notFound && (
              <div className="peq-not-found">
                <div className="peq-state-icon red"><i className="fal fa-user-slash" /></div>
                <h3>No Records Found</h3>
                <p>No student is linked to mobile number <strong>{mobile}</strong>. Please check the number and try again.</p>
                <button className="peq-retry-btn" onClick={this.handleReset}>
                  <i className="fal fa-arrow-left" />Try Again
                </button>
              </div>
            )}

            {/* Empty / initial */}
            {!loading && !notFound && !record && (
              <div className="peq-empty-state">
                <div className="peq-state-icon green"><i className="fal fa-comments" /></div>
                <h3>Ask Anything About Your Child</h3>
                <p>Search with your mobile number, then ask any question — attendance, marks, fees, timetable and more.</p>
                <div style={{ marginTop: 24 }}>
                  <p className="peq-demo-label">Try a demo number</p>
                  <div className="peq-demo-chips">
                    {DEMO_NUMBERS.map((d) => (
                      <button key={d.num} className="peq-demo-chip" onClick={() => this.tryDemo(d.num)}>
                        <i className="fal fa-user" />{d.num} — {d.name}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Chat area */}
            {!loading && record && (
              <>
                {/* Student bar */}
                <div className="peq-student-bar">
                  <div className="peq-sb-avatar">{initials(record.student.name)}</div>
                  <div className="peq-sb-info">
                    <p className="peq-sb-name">{record.student.name}</p>
                    <p className="peq-sb-meta">
                      Class {record.student.class}-{record.student.section} &nbsp;·&nbsp;
                      {record.student.admissionNo} &nbsp;·&nbsp;
                      {record.student.institution}
                    </p>
                  </div>
                  <div className="peq-sb-tags">
                    <span className="peq-sb-tag">
                      {record.student.attendance.overall}% Attendance
                    </span>
                    <span className="peq-sb-tag">
                      Rank {record.student.exams[0].rank}/{record.student.exams[0].totalStudents}
                    </span>
                  </div>
                  <button className="peq-sb-clear" onClick={this.handleReset} title="New search">
                    <i className="fal fa-times" />
                  </button>
                </div>

                {/* Chat window */}
                <div className="peq-chat-wrap">
                  {/* Chat header */}
                  <div className="peq-chat-header">
                    <div className="peq-chat-ai-dot"><i className="fal fa-robot" /></div>
                    <div className="peq-chat-ai-info">
                      <p className="peq-chat-ai-name">AI Assistant</p>
                      <p className="peq-chat-ai-status">Online — ready to help</p>
                    </div>
                    {/* Topic chips */}
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                      {WELCOME_SUGGESTIONS.map((s2) => (
                        <button
                          key={s2.label}
                          onClick={() => this.handleTopicChip(s2.label)}
                          style={{
                            background: '#f3f4f6', border: '1px solid #e5e7eb',
                            borderRadius: 20, padding: '4px 10px', fontSize: 11.5,
                            color: '#374151', cursor: 'pointer', display: 'flex',
                            alignItems: 'center', gap: 4, transition: 'all 0.15s',
                            fontWeight: 500,
                          }}
                          onMouseOver={(e) => { e.currentTarget.style.background = '#1d9c6e'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = '#1d9c6e'; }}
                          onMouseOut={(e) => { e.currentTarget.style.background = '#f3f4f6'; e.currentTarget.style.color = '#374151'; e.currentTarget.style.borderColor = '#e5e7eb'; }}
                        >
                          <i className={s2.icon} style={{ fontSize: 10 }} />{s2.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Messages */}
                  <div className="peq-chat-messages">
                    {messages.map((msg) =>
                      msg.role === 'ai' ? this.renderAIMessage(msg) : this.renderUserMessage(msg)
                    )}
                    {aiTyping && this.renderTypingIndicator()}
                    <div ref={this.messagesEndRef} />
                  </div>

                  {/* Suggestions */}
                  {suggestions.length > 0 && !aiTyping && (
                    <div className="peq-suggestions">
                      <p className="peq-suggestions-label">Suggested questions</p>
                      <div className="peq-chips-row">
                        {suggestions.map((s2, i) => (
                          <button key={i} className="peq-chip" onClick={() => this.handleSuggestion(s2)}>
                            <i className="fal fa-bolt" />{s2}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Input */}
                  <div className="peq-chat-input-area">
                    <textarea
                      ref={this.inputRef}
                      rows={1}
                      placeholder={`Ask about ${record.student.name}'s attendance, marks, fees…`}
                      value={inputText}
                      onChange={(e) => this.setState({ inputText: e.target.value })}
                      onKeyDown={this.handleInputKeyDown}
                    />
                    <button
                      className="peq-send-btn"
                      onClick={this.handleSend}
                      disabled={!inputText.trim() || aiTyping}
                      title="Send"
                    >
                      <i className="fal fa-paper-plane" />
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </Container>

        {/* Toast */}
        {toast && (
          <div className="peq-toast">
            <i className="fal fa-info-circle" />
            {toast}
          </div>
        )}
      </div>
    );
  }
}

export default ParentEnquirySection;
